export default __webpack_public_path__ + "static/media/assets_audio_correct_answer_chyme.806918ca.mp3";